import { DateTime } from 'luxon';
import { displayMessage } from '../../../services/helper';

export default [
    {
        field: 'fullName',
        headerName: displayMessage('NAME'),
        width: 200,
        valueGetter: function (params) {
            return `${params.row.full_name || ''}`
        }
    },
    {
        field: 'email',
        headerName: displayMessage('EMAIL'),
        width: 200,
        valueGetter: function (params) {
            return `${params.row.email}`
        }
    },
    {
        field: 'cpf',
        headerName: displayMessage('CPF'),
        width: 200,
    },
    {
        field: 'identificator',
        headerName: displayMessage('IDENTIFIER'),
        width: 200,
    },
    {
        field: 'birth_date', type: 'date', headerName: 'Data de Nascimento', width: 220, headerClassName: 'grid-headers-bold',
        valueFormatter: (params) => {
            if (!params?.value) { return params?.value }
            const data = DateTime.fromISO(params.value)
            return data.toFormat('dd/MM/yyyy')
        }
    },
]